import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import Dashboard from './DashboardContainer';
import Dashboard2 from './containers/Dashboard';
import {
  requireDashboardViewPermission,
} from '../../../auth/routerHooks';

const Routes = store => (
  <Route path="dashboard" onEnter={requireDashboardViewPermission(store)} >
    <IndexRoute component={Dashboard} />
    <Route path="v2" component={Dashboard2} />
  </Route>
);

export const BrandRoutes = store => (
  <Route path="dashboard" onEnter={requireDashboardViewPermission(store)} >
    <Route path="v2" component={Dashboard2} />
  </Route>
);

export default Routes;
